module.exports = __webpack_public_path__ + "img/321-11b1f2.png";